// src/components/Listings.js
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const Listings = () => {
  const { user } = useContext(AuthContext);
  const [listings, setListings] = useState([]);

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("http://localhost:5000/api/listings", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setListings(res.data);
      } catch (err) {
        console.error("Error fetching listings:", err);
      }
    };

    fetchListings();
  }, []);

  return (
    <div>
      <h2>Listings</h2>
      {listings.map((listing) => (
        <div key={listing._id} style={{ border: "1px solid #ccc", marginBottom: "10px", padding: "10px" }}>
          <h3>{listing.title}</h3>
          <p>{listing.description}</p>
          <p><strong>Category:</strong> {listing.category}</p>
          <p><strong>Location:</strong> {listing.location}</p>
          <p><strong>Price:</strong> {listing.price}</p>
          <p><strong>By:</strong> {listing.userId?.name} ({listing.role})</p>
        </div>
      ))}
    </div>
  );
};

export default Listings;
